var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36338 4.522L2.69938 2.856L1.35538 3.962L0.725383 2.898L2.36338 2.338L0.725383 1.764L1.35538 0.699999L2.69938 1.806L2.36338 0.14H3.63738L3.31538 1.806L4.64538 0.699999L5.27538 1.764L3.63738 2.338L5.27538 2.898L4.64538 3.962L3.31538 2.856L3.63738 4.522H2.36338Z",
    fill: "#4072DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpo);
export default __webpack_public_path__ + "static/media/impo.cfbf92ae34ab3b0a4152d5eac93a2b6a.svg";
export { ForwardRef as ReactComponent };